import {_get, _post, _put, clubId} from "@api/doinsport/services/httpService";

const URL = 'clubs/bank-configurations';

export const getClubBankConfig= () => _get(URL + clubId);

export const postClubBankConfig = (data) => _post(URL , data);
